export default __webpack_public_path__ + "static/media/default_treelists_tree_img.24b2965e.png";